var $12d0e5788525365a$exports = {};
$12d0e5788525365a$exports = {
    "backButton": (args)=>`Torna a ${args.prevMenuButton}`,
    "moreActions": `Altre azioni`,
    "unavailable": `Non disponibile, espandi per i dettagli`
};


export {$12d0e5788525365a$exports as default};
//# sourceMappingURL=it-IT.mjs.map
